export var BeneficialOwnerType;
(function (BeneficialOwnerType) {
    BeneficialOwnerType["Controller"] = "CONTROLLER";
    BeneficialOwnerType["ShareHolder"] = "SHARE_HOLDER";
    BeneficialOwnerType["Other"] = "OTHER";
})(BeneficialOwnerType || (BeneficialOwnerType = {}));
//# sourceMappingURL=BeneficialOwnerType.js.map